import { create } from 'zustand';

export type ConnectionStatus =
  | 'connecting'
  | 'connected'
  | 'disconnected'
  | 'reconnecting';

type ConnectionState = {
  status: ConnectionStatus;
  latencyMs: number | null;
  reconnectCount: number;
  clientId: string | null;
  setStatus: (status: ConnectionStatus) => void;
  setLatency: (ms: number) => void;
  incrementReconnect: () => void;
  setClientId: (id: string | null) => void;
};

export const useConnectionStore = create<ConnectionState>()((set) => ({
  status: 'disconnected',
  latencyMs: null,
  reconnectCount: 0,
  clientId: null,
  setStatus: (status) => set({ status }),
  setLatency: (latencyMs) => set({ latencyMs }),
  incrementReconnect: () =>
    set((s) => ({ reconnectCount: s.reconnectCount + 1 })),
  setClientId: (clientId) => set({ clientId }),
}));
